const actions = {
  setName: 'SET::SET_USERNAME'
}

export const setUserName = name => ({ type: actions.setName, userName: name })

export default actions
